import { useQuery } from '@tanstack/react-query'
import { getSticker } from '../../service/list'

function useGetSticker() {
  return useQuery({
    queryKey: ['get-sticker'],
    queryFn: () => getSticker(),
    staleTime: 6 * 1000,
  })
}

export default useGetSticker
